import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faqs" aria-labelledby="faqs-title" className="border-t border-line bg-mint py-20 text-ink lg:py-24" data-id="element-470" data-mp="x5mvahlnetpa">
      <div className="mx-auto max-w-3xl px-5 lg:px-8" data-id="element-471" data-mp="1ps7kbbenitpo">
        <SectionHeading id="faqs-title" tone="light" eyebrow="FAQ" lead="Frequently asked" highlight="questions" data-id="element-472" data-mp="1ptir7k3e8hl0" />

        <ul className="mt-12 space-y-3" data-id="element-473" data-mp="1uqislhpasw5s">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const buttonId = `faq-button-${index}`;
          const panelId = `faq-panel-${index}`;
          return <li key={faq.question} className={`border bg-white ${isOpen ? 'border-forest' : 'border-line'}`} data-id="element-474" data-mp="28qtm6shzsoun" data-mpi={index}>
                <h3 data-id="element-475" data-mp="2ditr6zcx67y3">
                  <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex min-h-[64px] w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6" data-id="element-476" data-mp="2djd2vybz803o">
                    <span className="text-[17px] font-bold leading-snug" data-id="element-477" data-mp="2tnqww1ham6dw">{faq.question}</span>
                    <span aria-hidden="true" className={`flex h-9 w-9 shrink-0 items-center justify-center transition-colors duration-150 ${isOpen ? 'bg-forest text-gold' : 'bg-cream text-forest'}`} data-id="element-478" data-mp="37ff9s6zd8yvx">
                      <PlusIcon strokeWidth={2.75} className={`h-5 w-5 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-479" data-mp="3cgkyzutti40p" />
                    </span>
                  </button>
                </h3>
                <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!isOpen} data-id="element-480" data-mp="27rii4w8c10qq">
                  <p className="px-5 pb-6 text-base leading-relaxed text-body sm:px-6" data-id="element-481" data-mp="2bsau3x8l9jqp">{faq.answer}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}